<template>
  <div>
    <section v-for="(segment, i) in segmentedList"
    :key="i"
    :id="'section' + (i+1)">
      <template v-for="(notice, j) in segment">
        <div :key="`spacer${j}`" v-if="spacerMonth(notice)" class="month_container">
            <v-spacer
              class="middle-hr my-2 my-md-0"
              :style="{
                borderColor: $vuetify.theme.currentTheme.primary,
                width: $vuetify.breakpoint.mdAndUp ? 'initial' : '100%'
              }"
            >{{ (getMonth(notice)) }}</v-spacer>
          </div>
        <h3
        :class="selectedIndex === (i*7 + j) ? 'indexed' : ''"
        :style="{marginTop: '3rem',marginBottom: '1rem'}"
        :key="`a${ segmentedList[0].length + (i-1)*7 + j }`"
        :ref="`a${segmentedList[0].length + (i-1)*7 + j }`"
        :id="`a${segmentedList[0].length + (i-1)*7 + j }`"
        >
          {{ getDayString(notice) }}
        </h3>
        <template v-if="Array.isArray(notice)">
          <div v-for="item in notice" :key="item.REF_NUM">
            <NoticeComponent :data=item>
          </NoticeComponent>
          </div>
        </template>
        <template v-else>
          <div :key="`a${ segmentedList[0].length + (i-1)*7 + j }notice`">
            <p class="emptyDay">{{ $t('views.pulsoDigital.empty') }}</p>
          </div>
        </template>
      </template>
    </section>
  </div>
</template>

<script>
import { NoticeComponent } from '@/components'; //eslint-disable-line

export default {
  components: {
    NoticeComponent,
  },
  props: {
    items: Array,
    selectedDateFromCalendar: Date,
    stopAutoScroll: Boolean,
  },
  data() {
    return {
      segmentedList: [],
      selectedIndex: null,
      actualSelectedDate: null,
    };
  },
  watch: {
    selectedDateFromCalendar(newVal) {
      if (newVal) {
        this.actualSelectedDate = newVal;
      }
    },
    items() {
      this.segmentListByWeeks();
    },
  },
  mounted() {
    this.initIntersectionObserver();
  },
  methods: {
    segmentListByWeeks() {
      // Segmenta la lista por semanas
      const itemList = this.items;
      const newSegmentedList = [];
      let segment = [];

      itemList.forEach((item, index) => {
        if (this.isNewSegment(item)) {
          newSegmentedList.push(segment);
          segment = [];
        }
        segment.push(item);

        // Añade al listado de segmentos el último
        // segmento
        if (itemList.length === index + 1) {
          newSegmentedList.push(segment);
        }
      });

      this.segmentedList = newSegmentedList;
    },
    isNewSegment(day) {
      // Comprubeba si el día es lunes.
      // Para cada lunes se crea un nuevo segmento
      if (Array.isArray(day)) {
        const dateArray = new Date(this.parseDate(day[0].date));
        return dateArray.getDay() === 1;
      }
      return day.getDay() === 1;
    },
    parseDate(date) {
      const fecha = date.split('/');
      return new Date(`${fecha[1]}/${fecha[0]}/${fecha[2].substring(2, 4)}`);
    },
    getDayString(day) {
      const daysWeek = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      if (Array.isArray(day)) {
        const dateArray = new Date(this.parseDate(day[0].date));
        return `${daysWeek[dateArray.getDay()]} ${dateArray.getDate()}`;
      }
      return `${daysWeek[day.getDay()]} ${day.getDate()}`;
    },
    initIntersectionObserver() {
      const options = {
        threshold: 0.5,
      };

      const observer = new IntersectionObserver(
        (entries, observer) => { // eslint-disable-line
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!this.stopAutoScroll) {
                this.$emit('updateStopAutoScroll', true);
                this.updateCalendar(entry.target.id);
                this.$emit('updateStopAutoScroll', false);
              }
            }
          });
        },
        options,
      );

      const sections = document.querySelectorAll('section');
      sections.forEach((section) => {
        observer.observe(section);
      });
    },
    updateCalendar(newSection) {
      const newSectionIndex = parseInt(newSection.replace('section', '')); // eslint-disable-line

      const firstItemNewSection = this.segmentedList[newSectionIndex - 1][0];

      let firstDaySection = firstItemNewSection;
      if (Array.isArray(firstItemNewSection)) {
        const aux = firstItemNewSection[0].date.split('/');
        firstDaySection = new Date(`${aux[1]}/${aux[0]}/${aux[2]}`);
      }

      if (!this.checkIsActualSection(newSectionIndex - 1)) {
        if (new Date(firstDaySection).getTime() > new Date(this.actualSelectedDate).getTime()) {
          this.$emit('clickCalendarArrowFromSection', 'right', firstDaySection);
        } else {
          this.$emit('clickCalendarArrowFromSection', 'left', firstDaySection);
        }
      }
      this.actualSelectedDate = firstDaySection;
    },
    spacerMonth(notice) {
      if (Array.isArray(notice)) {
        return notice[0].date.split('/')[0] === '01';
      }
      const dateAux = new Date(notice);
      return dateAux.getDate().toString() === '1';
    },
    getMonth(notice) {
      const month = this.$getConst('month');
      if (Array.isArray(notice)) {
        const monthAux = notice[0].date.split('/')[1];
        return month[parseInt(monthAux, 10) - 1];
      }
      const dateAux = new Date(notice);
      return month[dateAux.getMonth()];
    },
    selectIndex(selectedDate) {
      this.actualSelectedDate = selectedDate;
      const date = new Date(selectedDate);
      const day = date.getDate();
      const month = date.getMonth();
      const year = date.getFullYear();

      const dateIndex = new Date(year, month, day);
      let findDate = -1;
      this.items.forEach((i, index) => {
        const f = new Date(i);
        if (!Array.isArray(i) && this.compareDate(f, dateIndex)) {
          findDate = index;
        } if (Array.isArray(i)) {
          i.forEach((d) => {
            const fechaD = new Date(this.parseDate(d.date));
            if (this.compareDate(fechaD, dateIndex)) {
              findDate = index;
            }
          });
        }
      });
      this.selectedIndex = findDate;
      setTimeout(() => { this.desplazarAElemento(this.selectedIndex); }, 400);
      setTimeout(() => { this.$emit('updateStopAutoScroll', false); }, 2000);
      // this.$emit('updateStopAutoScroll', false);
    },
    compareDate(a, b) {
      return (a.getDate() === b.getDate()
            && a.getMonth() === b.getMonth()
            && a.getFullYear() === b.getFullYear());
    },
    desplazarAElemento(elemento) {
      if (elemento) {
        const elem = document.getElementById(`a${elemento}`);
        elem.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    checkIsActualSection(newSection) {
      const section = this.segmentedList[newSection];
      const actualDay = new Date(this.actualSelectedDate).getDate();

      const daysOfSection = section.map((day) => {
        if (Array.isArray(day)) {
          return new Date(day[0].date).getDate();
        }
        return new Date(day).getDate();
      });

      return daysOfSection.includes(actualDay);
    },
  },
  created() {
    // Cuando el componente se crea, se construye uno nuevo agrupando
    // los días en semanas, segmentando así el listado para la sincronización
    // del calendario con el listado de días
    this.$emit('updateStopAutoScroll', true);
    this.segmentListByWeeks();
    this.selectIndex(new Date());
  },
};
</script>

<style scoped>
  .month_container {
    margin: 1.5rem 0 !important;
  }
  .middle-hr {
    border-color: inherit;
    border-width: 2px 0;
    border-style: solid;
    display: flex;
    justify-content: center;
    color:rgb(39, 132, 109);
    padding-bottom: 0.3rem;
    padding-top: 0.3rem;
    font-size: 17px;
  }

</style>
